import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Rect} from 'react-native-svg';

const PrintedBarcodes: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Rect
        width={30.657}
        height={13.304}
        x={1}
        y={12.455}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 1 12.455)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={4.132}
        y={13.706}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 4.132 13.706)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={6.987}
        y={13.245}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 6.987 13.245)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={9.271}
        y={12.876}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 9.271 12.876)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={11.556}
        y={12.507}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 11.556 12.507)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={20.692}
        y={11.031}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 20.692 11.03)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={26.402}
        y={10.108}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 26.402 10.108)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={14.981}
        y={11.953}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 14.981 11.953)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={16.694}
        y={11.677}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 16.694 11.677)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={18.408}
        y={11.4}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 18.408 11.4)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={24.118}
        y={10.477}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 24.118 10.477)"
      />
      <Rect
        width={30.657}
        height={13.304}
        x={4.112}
        y={31.717}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 4.112 31.717)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={7.244}
        y={32.969}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 7.244 32.969)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={10.1}
        y={32.508}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 10.1 32.508)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={12.384}
        y={32.139}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 12.384 32.139)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={14.668}
        y={31.77}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 14.668 31.77)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={23.805}
        y={30.294}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 23.805 30.294)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={29.515}
        y={29.371}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 29.515 29.37)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={18.094}
        y={31.216}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 18.094 31.216)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={19.807}
        y={30.939}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 19.807 30.94)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={21.52}
        y={30.662}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 21.52 30.662)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={27.23}
        y={29.74}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 27.23 29.74)"
      />
      <Rect
        width={30.657}
        height={13.304}
        x={7.225}
        y={50.98}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 7.225 50.98)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={10.356}
        y={52.232}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 10.356 52.232)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={13.212}
        y={51.771}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 13.212 51.77)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={15.496}
        y={51.402}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 15.496 51.402)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={17.78}
        y={51.033}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 17.78 51.033)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={26.917}
        y={49.556}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 26.917 49.556)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={32.627}
        y={48.633}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 32.627 48.633)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={21.206}
        y={50.479}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 21.206 50.479)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={22.919}
        y={50.202}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 22.919 50.202)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={24.633}
        y={49.925}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 24.633 49.925)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={30.343}
        y={49.003}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 30.343 49.003)"
      />
      <Rect
        width={30.657}
        height={13.304}
        x={10.338}
        y={70.243}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 10.338 70.243)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={13.47}
        y={71.494}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 13.47 71.494)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={16.325}
        y={71.033}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 16.325 71.033)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={18.609}
        y={70.664}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 18.61 70.664)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={20.894}
        y={70.295}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 20.894 70.295)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={30.03}
        y={68.819}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 30.03 68.819)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={35.74}
        y={67.896}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 35.74 67.896)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={24.319}
        y={69.741}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 24.32 69.741)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={26.032}
        y={69.465}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 26.032 69.465)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={27.746}
        y={69.188}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 27.746 69.188)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={33.456}
        y={68.265}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 33.456 68.265)"
      />
      <Rect
        width={30.657}
        height={13.304}
        x={36.899}
        y={6.654}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 36.9 6.654)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={40.031}
        y={7.906}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 40.031 7.906)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={42.887}
        y={7.444}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 42.887 7.444)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={45.171}
        y={7.075}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 45.17 7.075)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={47.455}
        y={6.706}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 47.455 6.706)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={56.592}
        y={5.23}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 56.592 5.23)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={62.302}
        y={4.307}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 62.302 4.307)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={50.881}
        y={6.152}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 50.88 6.152)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={52.594}
        y={5.876}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 52.594 5.876)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={54.307}
        y={5.599}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 54.307 5.599)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={60.018}
        y={4.677}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 60.018 4.677)"
      />
      <Rect
        width={30.657}
        height={13.304}
        x={40.012}
        y={25.916}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 40.012 25.916)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={43.144}
        y={27.168}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 43.144 27.168)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={45.999}
        y={26.707}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 45.999 26.707)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={48.283}
        y={26.338}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 48.283 26.338)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={50.567}
        y={25.969}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 50.567 25.969)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={59.704}
        y={24.492}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 59.704 24.492)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={65.414}
        y={23.57}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 65.414 23.57)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={53.993}
        y={25.415}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 53.993 25.415)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={55.706}
        y={25.138}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 55.706 25.138)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={57.42}
        y={24.862}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 57.42 24.862)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={63.13}
        y={23.939}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 63.13 23.939)"
      />
      <Rect
        width={30.657}
        height={13.304}
        x={43.124}
        y={45.18}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 43.124 45.18)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={46.256}
        y={46.431}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 46.256 46.431)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={49.111}
        y={45.97}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 49.111 45.97)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={51.395}
        y={45.601}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 51.395 45.601)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={53.68}
        y={45.232}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 53.68 45.232)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={62.816}
        y={43.756}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 62.816 43.756)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={68.526}
        y={42.833}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 68.526 42.833)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={57.105}
        y={44.678}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 57.105 44.678)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={58.818}
        y={44.402}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 58.818 44.402)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={60.531}
        y={44.125}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 60.531 44.125)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={66.242}
        y={43.202}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 66.242 43.202)"
      />
      <Rect
        width={30.657}
        height={13.304}
        x={46.236}
        y={64.443}
        fill="#fff"
        stroke="#100E3A"
        strokeWidth={2.3}
        rx={1.957}
        transform="rotate(-9.178 46.236 64.443)"
      />
      <Rect
        width={1.735}
        height={9.833}
        x={49.368}
        y={65.694}
        fill="#100E3A"
        rx={0.868}
        transform="rotate(-9.178 49.368 65.694)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={52.224}
        y={65.233}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 52.224 65.233)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={54.508}
        y={64.864}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 54.508 64.864)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={56.792}
        y={64.495}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 56.792 64.495)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={65.929}
        y={63.019}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 65.929 63.019)"
      />
      <Rect
        width={2.314}
        height={9.833}
        x={71.639}
        y={62.096}
        fill="#100E3A"
        rx={1.157}
        transform="rotate(-9.178 71.639 62.096)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={60.218}
        y={63.941}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 60.218 63.941)"
      />
      <Rect
        width={0.578}
        height={9.833}
        x={61.932}
        y={63.665}
        fill="#100E3A"
        rx={0.289}
        transform="rotate(-9.178 61.932 63.665)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={63.645}
        y={63.388}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 63.645 63.388)"
      />
      <Rect
        width={1.157}
        height={9.833}
        x={69.355}
        y={62.465}
        fill="#100E3A"
        rx={0.578}
        transform="rotate(-9.178 69.355 62.465)"
      />
    </Icon>
  );
};

export default PrintedBarcodes;
